import { Component } from "../../../../modules/Core/Component";
import templateDefault from "../../../templates/default/widgets/dialogs/contact_us";
import Services from "../../../Services/Services";

export default class ContactUs extends Component {
  id = "contact-us";

  template = templateDefault;

  onLoad(data) {
    super.onLoad(data);
    var open = this.props.open;

    this.setData({
      "default.open": open,
      "default.fields": {
        name: "",
        email: "",
        phone: "",
        message: "",
      },
    });
  }

  sendRequest(e) {
    e.preventDefault();

    const { fields } = this.getData("default", {
      name: "",
      email: "",
      phone: "",
      message: "",
    });

    const error = {
      fields: {},
    };

    const { name, email, phone, message } = this.getData("default.fields", {});

    if (!name) {
      error.fields["name"] = this.ucfirst("fullname-helpertext");
    }

    if (!email) {
      error.fields["email"] = this.ucfirst("email-helpertext");
    } else {
      if (!this.getHelpers("validate").email(email)) {
        error.fields["email"] = this.ucfirst("invalid-email");
      }
    }

    if (phone && phone.length !== 10) {
      error.fields["phone"] = this.ucfirst("phone-helpertext-2");
    }

    if (!message) {
      error.fields["message"] = this.ucfirst("message-helpertext");
    }

    this.setData({
      error,
    });

    if (Object.keys(error.fields).length === 0) {
      Services.get("hook").then(async ([hookService]) => {
        await hookService.post("contact-us", fields);

        this.setData({
          "default.fields": {
            name: "",
            email: "",
            phone: "",
            message: "",
          },
        });

        this.props.setOpen(false);

        this.getComponents()
          .findById("main-message")
          .first()
          .setData({
            "message-duration": 2000,
            "success-message": this.trans("message-send"),
          });
      });
    }
  }
}
